import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../utils/api';
import {
  applyValidatedReferralCode,
  clearStoredReferralCode,
  normalizeReferralCode,
  stripReferralParamsFromUrl,
} from '../utils/referralStorage';

/**
 * Captures ?ref=CODE for signup attribution.
 * If the referrer has reached their admin cap, clears attribution and strips
 * the ref param so the visitor registers as a normal (unattributed) user.
 */
export default function ReferralCapture() {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    async function run() {
      try {
        const params = new URLSearchParams(location.search);
        const raw = params.get('ref') || params.get('referral');
        const code = normalizeReferralCode(raw);
        if (!code) return;

        const { data } = await api.get(`/referrals/validate/${encodeURIComponent(code)}`);
        if (cancelled) return;

        if (data?.valid) {
          applyValidatedReferralCode(code, { valid: true });
          return;
        }

        // Cap reached or invalid — do not attribute; clean URL for normal signup.
        clearStoredReferralCode();
        applyValidatedReferralCode(code, { valid: false, capped: Boolean(data?.capped) });
        stripReferralParamsFromUrl();
      } catch {
        // Keep URL/code on network errors so attribution can retry on next navigation.
      }
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [location.search]);

  return null;
}
